import {storage} from "./storage";
import {APIResponse} from "interfaces";

export async function postFormData<T>(uri: string, data: FormData) {
  const headers = new Headers();

  headers.append(
    "Authorization",
    `Bearer ${storage["read"]("[auth-token]")}` as string,
  );
  try {
    const response = await fetch(`${process.env.REACT_APP_PUBLIC_API}${uri}`, {
      body: data,
      method: "POST",
      headers: headers,
      redirect: "follow",
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || response.statusText);
    }

    return (await response.json()) as APIResponse<T>;
  } catch (error: any) {
    throw new Error(error?.message);
  }
}
